module.exports = __webpack_public_path__ + "static/media/carnation5.6bc07dfb.jpg";